import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import defaultPic from './default-pic.png'
import styles from './PortfolioCard.module.scss'
import { Link } from 'react-router'

class PortfolioCard extends React.Component {
  
  static propTypes () {
    return {
      data: React.PropTypes.object,
    }
  }

  render () {
    const data = this.props.data;
    const pic = this.props.data.thumb || defaultPic;
    const linkLabel = this.props.data.linkLabel || 'More Details';
    const disableDetail = this.props.data.disableDetail || false;
    return (
      <div className={styles.portfolioCard}>
        <h3 className={styles.header}>{data.name}</h3>
        <p className={styles.subHeader}>{data.product}</p>
        <img src={prefixLink(pic)} />
        <p className={styles.description}>{data.description}</p>
        {!disableDetail &&
          <Link className="btn btn-malibu hvr-grow" to={prefixLink(data.path)}>
            {linkLabel}
          </Link>
        }
      </div>
    )
  }
}

export default PortfolioCard



/** WEBPACK FOOTER **
 ** ../components/PortfolioCard.js
 **/